export type { AccommodationsPageProps } from "./accommodations-page";
export { AccommodationsPage } from "./accommodations-page";
export { SingleAccommodationsPointPage } from "./single-accommodations-point-page";
